import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img 
                src="https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/922a6cc1bcbe4a849c9d8b3340221f4a.png" 
                alt="TopInstal Snajdr Logo" 
                className="h-10 w-10 object-contain brightness-0 invert"
              />
              <span className="text-xl font-bold">TopInstal Snajdr</span>
            </div>
            <p className="text-gray-300 mb-4">
              Profesionální instalatérské a topenářské práce v Mladé Boleslavi a okolí.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/topinstal_snajdr/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="https://www.facebook.com/profile.php?id=61560758253104" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">
                <i className="ri-facebook-line text-xl"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Kontakt</h3>
            <div className="space-y-2">
              <div className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                <a href="tel:+420720520035" className="text-gray-300 hover:text-white">
                  720 520 035
                </a>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                <a href="mailto:instatop.snajdr@post.cz" className="text-gray-300 hover:text-white">
                  instatop.snajdr@post.cz
                </a>
              </div>
              <div className="flex items-center">
                <i className="ri-map-pin-line mr-2"></i>
                <span className="text-gray-300">Vinec 57, 293 01 Mladá Boleslav</span>
              </div>
              <div className="flex items-center">
                <i className="ri-time-line mr-2"></i>
                <span className="text-gray-300">Non stop - havarijní služba</span>
              </div>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Služby</h3>
            <ul className="space-y-2 text-gray-300">
              <li>Instalatérské práce</li>
              <li>Topenářské práce</li>
              <li>Havarijní opravy</li>
              <li>Instalace sanitární techniky</li>
              <li>Opravy vodovodů</li>
              <li>Servis topení</li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm">
            <p>© 2025 TopInstal Snajdr. Všechna práva vyhrazena.</p>
            <p>IČ: 21645175 | Mladá Boleslav</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
